import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface Input {
    userId: string;
    sendEmail: boolean;
}

export function useInviteUserMutation() {
    return useMutation({
        mutationFn: async (input: Input) => {
            await apiClient.createUserInvite({
                params: { userId: input.userId },
                query: {
                    sendEmail: input.sendEmail ? "true" : "false",
                },
                body: null,
            });
        },
    });
}
